/**
 * Global JavaScript for Shree Gulab Chandi theme
 */

// Cart functionality
class CartDrawer {
  constructor() {
    this.init();
  }

  init() {
    // Cart drawer functionality can be added here
    console.log('Cart drawer initialized');
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartDrawer();
  });
} else {
  new CartDrawer();
}
